import type { BuilderConfig } from '@/types/builder';
import Link from '../Link';
import Btn from '../Btn';
import BtnCta from './BtnCta.vue';

export default {
    component: BtnCta,
    childComponents: [Link, Btn],
    docsLink: 'https://storybook.studydrive.net/?path=/story/components-buttons-btncta--docs',
} satisfies BuilderConfig;
